import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { Button, TextField } from "@jkast90/kast-common/ui";
import { errorText } from "@common/api";
import { queryKeys, signUp } from "../api/salvagers";

/** "Keep me posted": an email for Kickstarter and project updates. */
export default function SignupForm() {
  const [email, setEmail] = useState("");
  // Hidden from people, filled by bots; the API drops a sign-up that has it.
  const [website, setWebsite] = useState("");
  const queryClient = useQueryClient();
  const send = useMutation({
    mutationFn: () => signUp(email.trim(), website),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.tables }),
  });
  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (email.trim()) send.mutate();
  };

  if (send.isSuccess) {
    return (
      <p className="notice" role="status">
        Thanks! We'll let you know when there's news.
      </p>
    );
  }
  return (
    <form onSubmit={submit} className="signup">
      <div className="row">
        <TextField
          wrapperClassName="grow"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="you@example.com"
          aria-label="Email address"
          required
        />
        <Button variant="primary" type="submit" disabled={send.isPending || !email.trim()}>
          Keep me posted
        </Button>
      </div>
      <div className="honeypot" aria-hidden="true">
        <label>
          Website
          <input type="text" value={website} onChange={(event) => setWebsite(event.target.value)} tabIndex={-1} autoComplete="off" />
        </label>
      </div>
      <p className="muted small">
        We promise that we will only use your email for sending updates about the Salvagers project, Kickstarter, or
        any follow-up projects. We will not sell or give your email to anyone.
      </p>
      {send.error && <p className="notice error">{errorText(send.error, "That didn't work. Try again?")}</p>}
    </form>
  );
}
